import * as React from 'react';
import * as Styled from './styled';
import { Text, Card } from '@mlc/web-ui-toolkit';
import searchTestIds from '../SearchResults.elements';

export type Icon = {
	url: string;
	alt: string;
};

const NoSearchResults: React.FunctionComponent<Icon> = ({ url, alt }) => (
	<Styled.NoResultsContainer data-id={searchTestIds.noResultsContainer}>
		<Styled.Icon source={url} alt={alt} />
		<Card textAlign="center" paddingTop={3} paddingBottom={1}>
			<Text fontWeight="semibold" fontSize="regular">
				We couldn&apos;t find anything that quite matches your search.
			</Text>
		</Card>
		<Card textAlign="center">
			<Text>
				Perhaps try updating your search criteria or removing some filters.
			</Text>
		</Card>
	</Styled.NoResultsContainer>
);

export default NoSearchResults;
